import { render } from "./RegisterOrUploadIso.vue?vue&type=template&id=552fe825&scoped=true"
import script from "./RegisterOrUploadIso.vue?vue&type=script&lang=js"
export * from "./RegisterOrUploadIso.vue?vue&type=script&lang=js"

import "./RegisterOrUploadIso.vue?vue&type=style&index=0&id=552fe825&scoped=true&lang=less"

import exportComponent from "/root/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-552fe825"]])

export default __exports__